module.exports = __webpack_public_path__ + "img/title.6fe5cad5.png";